import React from "react";
import "./EcoInov.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class EcoInov extends React.Component {
    render() {
        return(
<div>
    <Nav/>
            <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Investment Environment</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">Transportation and Logistics</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/InvestRegis"> 02 Investment Registration</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab">03 Industries & Parks</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoBusiness">Eco-Business Park</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoInov"> Eco-Innovation </a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Overall"> Overall Introduction </a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab">04 Real Estate Development</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">Development Plan</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevMile">Development Milestone</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">05 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Eco-Innovation Park</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}></p>
        <p className="text-justify">The Eco-Innovation Park will be located in the north of the Eco-City and will cover a planned area of 65 Acres, with both ready-built facilities and land plots for eco-industrial players to establish their Central Regional industrial bases in Ghana. Built in compliance with IFC-EDGE Standards - green building evaluation standards, this green industrial park will feature eco technologies such as energy-efficient building materials – Lime & Bamboo Composite, etc., solar technologies and rainwater harvesting/Waste Water Treatment. This will allow business owners to enjoy direct savings.

</p>
   <p style={{margin: 0, fontWeight: 'bold', fontSize: '24px', color: 'green'}}>Land Plots</p>
   <ul><li>•	Eco Industrial land plots will be available for investors.</li></ul>
   <br/><br/><p style={{margin: 0, fontWeight: 'bold', fontSize: '24px', color: 'green'}}>Ready Built Factories (RBFs)</p>
   <ul><li>•	3 RBFs with total floor area of 24,000 sqm will be completed by the end of second quarter of 2021 and ready for tenants.</li></ul>
      <li>•	Single and multi-level factory space will also be available.</li>
       </div>
      
     </div>
   </div>
</div>
        )
    }
}
export default withRouter(EcoInov);